/**
 * to make equipment family train case
 * @param text
 * @returns
 */

export const capitalizeText = (text: string) => {
  return text
    .toLowerCase()
    .replace(/(\b[a-z](?!\s))/g, (letter) => letter.toUpperCase());
};

export const getFamilyName = (modal: string, name: string | undefined) => {
  return name?.replace(modal, '')?.trim() ?? name;
};
